/** Query key for the 6-character storage ID prefix passed between Scan Label and destination pages. */
export const SCAN_LABEL_PREFIX_QUERY = 'prefix';
/** Query key: `1` lets Shelf Indexer load a checked-out label (Re-index from Scan Label). */
export const SCAN_LABEL_ALLOW_CHECKED_OUT_QUERY = 'allowCheckedOut';
/** Print page `type` that opens the Reprint panel. */
export const SCAN_LABEL_REPRINT_TYPE = 'reprint';
/** Print Event Handling → Scan Label: which print order to validate against. */
export const PRINT_EVENT_ORDER_QUERY = 'printEventOrder';
/** Scan Label → Print Event Handling: prefix that matched the job. */
export const PRINT_EVENT_SCANNED_QUERY = 'printEventScanned';
/** Path to reopen Print Event Handling after an in-job scan. */
export const PRINT_EVENT_RETURN_QUERY = 'printEventReturn';

/** Normalize a `?prefix=` value to a 6-char lowercase hex storage ID, or null. */
export function parseStorageIdPrefixParam(value: string | null | undefined): string | null {
  const trimmed = String(value || '').trim().toLowerCase();
  if (!/^[0-9a-f]{6}$/.test(trimmed)) return null;
  return trimmed;
}

export function shelfIndexerHandoffPath(prefix: string, allowCheckedOut: boolean): string {
  const params = new URLSearchParams({ [SCAN_LABEL_PREFIX_QUERY]: prefix });
  if (allowCheckedOut) params.set(SCAN_LABEL_ALLOW_CHECKED_OUT_QUERY, '1');
  return `/shelf-indexer?${params.toString()}`;
}

export function searchWarehouseHandoffPath(prefix: string): string {
  return `/search-warehouse?${SCAN_LABEL_PREFIX_QUERY}=${encodeURIComponent(prefix)}`;
}

export function reprintHandoffPath(prefix: string): string {
  return `/print-warehouse-labels/print?type=${SCAN_LABEL_REPRINT_TYPE}&${SCAN_LABEL_PREFIX_QUERY}=${encodeURIComponent(prefix)}`;
}

export function checkLabelHandoffPath(prefix: string): string {
  return `/print-warehouse-labels/check-label-out?${SCAN_LABEL_PREFIX_QUERY}=${encodeURIComponent(prefix)}`;
}

/** Relative path only — rejects protocol-relative and off-site URLs. */
export function parsePrintEventReturnParam(value: string | null | undefined): string | null {
  const trimmed = String(value || '').trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return null;
  return trimmed;
}

export function currentPrintEventReturnPath(pathname: string, search: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  params.delete(PRINT_EVENT_ORDER_QUERY);
  params.delete(PRINT_EVENT_SCANNED_QUERY);
  params.delete(PRINT_EVENT_RETURN_QUERY);
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}

export function printEventScanLabelPath(orderId: string, returnPath: string): string {
  const params = new URLSearchParams({
    [PRINT_EVENT_ORDER_QUERY]: orderId,
    [PRINT_EVENT_RETURN_QUERY]: returnPath,
  });
  return `/scan-label?${params.toString()}`;
}

export function printEventHandlingReturnPath(
  returnPath: string,
  orderId: string,
  scannedPrefix?: string | null,
): string {
  const qIndex = returnPath.indexOf('?');
  const path = qIndex >= 0 ? returnPath.slice(0, qIndex) : returnPath;
  const params = new URLSearchParams(qIndex >= 0 ? returnPath.slice(qIndex + 1) : '');
  params.set(PRINT_EVENT_ORDER_QUERY, orderId);
  if (scannedPrefix) params.set(PRINT_EVENT_SCANNED_QUERY, scannedPrefix);
  return `${path}?${params.toString()}`;
}
